
import React from 'react';
import axios2 from 'services/axios2';

import {useParams} from 'react-router-dom';
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { NuDropdown } from 'components/nubox/NuDropdown';
import NuLoading from 'components/nubox/NuLoading';
import NuAlert2 from 'components/NuAlert2';

import NuConfirm from "components/nubox/Box/NuConfirm";
import { withRouterJim } from "router/withRouterJim";

import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
} from 'reactstrap';
import { RssFeed } from '@material-ui/icons';

const data = [
  //{ id_medico: 1,  nombre: 'ALEX LIZARRAGA',  especialidad: '00000023',tel:''}, 
];
/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class PrograBuscarCi extends React.Component {  

  modalRef = React.createRef();//create ref
  nuRef = React.createRef(); //divres

  state = {
    modalInsertar: false,
    item_selected:{ id_est:0, nomape:'-', id_progra:''},
    cargando:false,

    form: {
      name: 0,
    },
    data: data,/* lista de datos */
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }
  //------------------
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de datos
    this.setState({data:[]});

    //this.buscar();
    
    //this.cargar_citas();
    console.log(this.modalRef);
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  setCargando =(flag)=>{
    this.setState({cargando: flag});
  }
  //====================================================== 
  buscar = () => {
    let param = { 
      param1: this.state.form.name,
      id_peri: this.props.store.user.id_peri,
    }
    console.log(param);
    this.setCargando(true);
    axios2.post( 'prograbuscarci_buscar', param)
    .then(res => {
        this.setCargando(false);
        console.log(res.data);
        
        if(res.data.exito==1 || res.data.exito==2 ){   // existe y no programao
          this.setState({ item_selected: res.data});    
        }else{
          // ci no exite
          this.nuRef.current.show({'type':'info', "text": res.data.men }); 
        }
        

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });
  };
  //======================================================     
  /* === This is where the magic happens ==== */
  handleSubmit = event => {
    event.preventDefault();
    this.buscar();
  }
  //-----------------------------------------------------------------  
  //-------------------------------------
  render() {
  
    return (
      <div>
        <ToastContainer />
        <div className='content'>

          {/*{/*--- -----------------------------*/}
          <div className='row'>
            <div className='col-md-12'>
              <h3> Buscar programación </h3>
            </div>
          </div>

          <div className="row d-flex justify-content-center">
              <div className='box box-info' style={{ width: "50%" }}>
                {/*-- box-header --*/}
                <div className='box-body pad'>

                  <form onSubmit={this.handleSubmit}>

                    <div className='row'>

                      <div className='col-md-6'>
                        <div className='form-group'>
                          <label className='control-label'>Busqueda por C.I.:</label>
                          <input 
                              type='text' 
                              name='name' 
                              onChange={this.handleChangeForm} 
                              className='form-control input-sm'
                              autoComplete='on'
                               />
                        </div>
                      </div>

                      <div className='col-md-6'>
                        <button type='submit' style={{ marginTop: '24px' }} 
                          className='btn btn-primary '>
                          <i className='fa fa-search'></i> Buscar</button>

                      </div>

                    </div>
                  </form>

                </div>
                {/* box-body */}
              </div>
          </div>

          <div className="row d-flex justify-content-center">
            <div style={{ width: "40%" }}>
              <NuLoading className="oso" show={this.state.cargando} text="Cargando..." />
              { this.state.item_selected.exito!=0 &&
                <div>
                  Estudiante:<br/>
                  { this.state.item_selected.nomape }
                  { this.state.item_selected.exito==1 && 
                    <Link to={`/programacionlist/${this.state.item_selected.id_est}`} className="btn btn-primary btn-sm"><i className="fa fa-plus"></i> Programar</Link>
                  }
                  { this.state.item_selected.exito==2 && 
                    <Link to={`/programacionlist/${this.state.item_selected.id_est}`} className="btn btn-primary btn-sm"><i className="fa fa-edit"></i> Ver Programación</Link>
                  }
                  
                </div>
              }
              <NuAlert2 ref={ this.nuRef } />
            </div>
          </div>

       
          
          {/*-- */}
        
          {/*-- */}

          

        </div>
      </div>
      
    );
  }
}
//------------para que soporte la funcionalidad de parametros
export default withRouterJim(PrograBuscarCi);
